'use strict';
define([], function () {
    function toHex(value) {
        var color = String(value || '').trim();
        if (/^#[a-f\d]{6}$/i.test(color)) return color.substring(1);
        if (/^#[a-f\d]{3}$/i.test(color)) {
            return color.substring(1).split('').map(function (digit) { return digit + digit; }).join('');
        }
        var rgb = color.match(/^rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)/i);
        if (rgb) {
            return rgb.slice(1, 4).map(function (channel) {
                return ('0' + Math.max(0, Math.min(255, Math.round(Number(channel)))).toString(16)).slice(-2);
            }).join('');
        }
        throw new Error('Suite theme tokens are missing or invalid. Load bundle.styles.css before the app.');
    }

    return function (readToken) {
        var palette = {};
        ['50', '100', '200', '300', '400', '500', '600', '700', '800', '900', 'A100', 'A200', 'A400', 'A700']
            .forEach(function (hue) {
                palette[hue] = toHex(readToken('--sto-color-primary-' + hue));
            });
        palette.contrastDefaultColor = 'light';
        palette.contrastDarkColors = ['50', '100', '200', '300', '400', 'A100'];
        return palette;
    };
});
